import {Stack} from 'shells/layout/stack/stack';
import {LoadingPage} from 'shells/loading-page/loading-page';

import {AiFeatureCategory} from 'nutshell-graphql-types';

import {BannerCueCards} from '../../glossary/layout/banner-cue-cards';

import {AiFeatureUsageSection} from './ai-feature-usage-section';
import {ASSIST_FEATURE_GROUPS, OUTCOME_FEATURE_GROUPS} from './feature-config';
import {useGetAiFeatureUsage} from './graphql/hooks/use-get-ai-feature-usage';
import {useToggleAiFeatureSetting} from './graphql/hooks/use-toggle-ai-feature-setting';

export function AiFeaturesPageV2() {
    const {aiFeatureUsage: outcomesData, isLoading: isOutcomesLoading} = useGetAiFeatureUsage(
        AiFeatureCategory.OUTCOME
    );
    const {aiFeatureUsage: assistsData, isLoading: isAssistsLoading} = useGetAiFeatureUsage(
        AiFeatureCategory.ASSIST
    );

    const {toggleFeatureSetting} = useToggleAiFeatureSetting();

    if (isOutcomesLoading || isAssistsLoading) {
        return <LoadingPage />;
    }

    return (
        <Stack spacing={16}>
            <BannerCueCards />
            {outcomesData && (
                <AiFeatureUsageSection
                    title='AI outcomes'
                    currentMonthUsage={outcomesData.currentMonthUsage}
                    currentMonthLimit={outcomesData.currentMonthLimit}
                    lastMonthUsage={outcomesData.lastMonthUsage}
                    features={outcomesData.features}
                    featureGroups={OUTCOME_FEATURE_GROUPS}
                    featureColumnHeader='Outcome features'
                    category={AiFeatureCategory.OUTCOME}
                    onToggle={toggleFeatureSetting}
                />
            )}
            {assistsData && (
                <AiFeatureUsageSection
                    title='AI assists'
                    subtitle='AI assists are unlimited in your plan'
                    currentMonthUsage={assistsData.currentMonthUsage}
                    currentMonthLimit={assistsData.currentMonthLimit}
                    lastMonthUsage={assistsData.lastMonthUsage}
                    features={assistsData.features}
                    featureGroups={ASSIST_FEATURE_GROUPS}
                    featureColumnHeader='Assist features'
                    category={AiFeatureCategory.ASSIST}
                    onToggle={toggleFeatureSetting}
                />
            )}
        </Stack>
    );
}
